import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ScholarshipManagementActions from './scholarship-management.actions';
import { ScholarshipManagementService } from '../../services/scholarship-management.service';
import { Router } from '@angular/router';

@Injectable()
export class ScholarshipManagementEffects {
  loadScholarshipManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipManagementActions.loadScholarshipManagement),
      exhaustMap((_) =>
        this.scholarshipManagementService.getScholarshipManagement().pipe(
          map((data) =>
            ScholarshipManagementActions.loadScholarshipManagementSuccess({
              scholarshipManagement: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ScholarshipManagementActions.loadScholarshipManagementFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addScholarshipManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipManagementActions.addScholarshipManagement),
      concatMap(({ newScholarshipManagement }) =>
        this.scholarshipManagementService
          .createScholarshipManagement(newScholarshipManagement)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ScholarshipManagementActions.addScholarshipManagementSuccess(
                {
                  newScholarshipManagement: data,
                }
              );
            }),
            catchError((error) =>
              of(
                ScholarshipManagementActions.addScholarshipManagementFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  uploadExcelScholarshipManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipManagementActions.uploadExcelStudentRecord),
      concatMap(({ uploadExcelRecord }) =>
        this.scholarshipManagementService
          .uploadExcelScholarshipManagement(uploadExcelRecord)
          .pipe(
            map((data) => {
              this.notification.success('Uploaded Successfully');
              return ScholarshipManagementActions.uploadExcelStudentRecordSuccess(
                {
                  uploadExcelRecord: data,
                }
              );
            }),
            catchError((error) =>
              of(
                ScholarshipManagementActions.uploadExcelStudentRecordFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateScholarshipManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipManagementActions.updateScholarshipManagement),
      concatMap(({ updateScholarshipManagement }) =>
        this.scholarshipManagementService
          .updateScholarshipManagement(updateScholarshipManagement)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ScholarshipManagementActions.updateScholarshipManagementSuccess(
                {
                  updateScholarshipManagement: data,
                }
              );
            }),
            catchError((error) => {
              return of(
                ScholarshipManagementActions.updateScholarshipManagementFailure(
                  { error: error.message }
                )
              );
            })
          )
      )
    )
  );

  // updateSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ScholarshipManagementActions.updateScholarshipManagementSuccess),
  // 			tap(() => {
  // 				console.log('navigate');
  // 				return this.router.navigate([ '/scholarship' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  removeScholarshipManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipManagementActions.removeScholarshipManagement),
      map((action) => action.ids),
      concatMap((ids) =>
        this.scholarshipManagementService.deleteScholarshipManagement(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ScholarshipManagementActions.removeScholarshipManagementSuccess(
              { ids }
            );
          }),
          catchError((error) =>
            of(
              ScholarshipManagementActions.updateScholarshipManagementFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private scholarshipManagementService: ScholarshipManagementService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
